import React, { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from "axios"

import { Container } from '../../Container';
import { InfoIcon, XIcon } from '../../Icons';
import { ContentListing } from './ContentListing';
import { CustomBuilder } from './CustomBuilder';

import './packaging-print-house.css';

export const PackagingPrintHouse = ({ pageData }) => {
    const [loading, setLoading] = useState(false)
    const [saveLoading, setSaveLoading] = useState(false)
    const [getDataShown, setGetDataShown] = useState(false)
    const [retrievedData, setRetrievedData] = useState(null);
    const [backdrop, setBackdrop] = useState(false)
    const [savedMessage, setSavedMessage] = useState(false)

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        company: '',
        location: '',
        quantity: '',
        downloadDieline: '',
        downloadDielineImage: '',
        file: null,
    });
    
    const initialFormData = {
        name: '',
        phone: '',
        email: '',
        company: '',
        location: '',
        quantity: '',
        downloadDieline: '',
        downloadDielineImage: '',
        file: null,
    };
    
    const handleChange = (e) => {
        const { name, value, files, image } = e.target;

        if (name === 'file') {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: files[0],
            }));
        } else if (name === 'downloadDieline') {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
                downloadDielineImage: image
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
        }
    };
    
    const onDrop = useCallback((acceptedFiles) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            file: acceptedFiles[0],
        }));
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: '.pdf, .svg, .ai'
    });
    
    const handlePackagingBuilder = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)

            await axios.post('https://2n2kzk2zb9.execute-api.us-west-2.amazonaws.com/staging/send-email', retrievedData);

            setFormData(initialFormData);
            setGetDataShown(false);
            setLoading(false)
            fetchData();
            setBackdrop(false);
            setSavedMessage(true)
            setTimeout(() => {
                setSavedMessage(false);
            }, 2000);
        } catch (error) {
            alert('Form submission failed. Please try again.');
        }
    };

    const handleSavePackagingBuilder = async (e) => {
        e.preventDefault();
        try {
            setSaveLoading(true);
            const { file, ...otherData } = formData;

            const requestData = {
                ...otherData,
                status: 'pending',
                file: file ? {
                    name: file.name,
                    type: file.type,
                    content: (await getBase64(file)).split(',')[1]
                } : undefined
            };

            await axios.post('https://2n2kzk2zb9.execute-api.us-west-2.amazonaws.com/staging/savedata', requestData);
    
            setSaveLoading(false);

            setFormData(prevFormData => ({
                ...prevFormData,
                quantity: '',
                downloadDieline: '',
                downloadDielineImage: '',
                file: null,
            }));

            fetchData();
    
        } catch (error) {
            alert('Form submission failed. Please try again.');
            setSaveLoading(false);
        }
    };    

    const handleGetData = async (e) => {
        e.preventDefault();
        try {
            setGetDataShown(true);
            setBackdrop(true);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const fetchData = async () => {
        try {
            const userEmail = localStorage.getItem('userEmail');

            const response = await axios.get('https://2n2kzk2zb9.execute-api.us-west-2.amazonaws.com/staging/getdata');
            const responsePending = response.data.filter((item) => item.Status === 'pending' && item.Email === userEmail);

            setRetrievedData(responsePending);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(()=>{
        if(getDataShown) {
            document.documentElement.classList.add("html--menu-open");
        } else  document.documentElement.classList.remove("html--menu-open");
        return () => {
            document.documentElement.classList.remove("html--menu-open");
        };
    },[getDataShown])

    useEffect(() => {
        fetchData();
    }, []);
    
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    if(pageData.id === '82ca84a0-d2ac-5b3c-a3f9-01716ae582c1') {
        const details = [
            {
                image: 'https://images.ctfassets.net/tg5mrahr7vmv/1BmdqYFbBl2bXmfuTgnps3/48df45a760a9253564d3d1d95f70d44b/standuppouch.png',
                image1: 'https://images.ctfassets.net/vhts96p7twn6/Xwf7hJ9KHyVt3eoDM9FZY/1e937e63c64ac0cdda5bdbc30fe880bd/SUP_bottom.png',
                val: 'Stand Up Pouch',
                description: 'Stand out on the shelf with a wide design area, sturdy base, and convenient zipper closure, the ideal cost-effective option for coffee and food products.'
            },{
                image: 'https://images.ctfassets.net/tg5mrahr7vmv/1WuVw69299P3eJTy6xoi62/3ae5624e1c0ab7b433ed73b59049756a/t-shape_image.png',
                image1: 'https://images.ctfassets.net/vhts96p7twn6/1kxrYj68ofVBftcstiQHZJ/a2f464839adad69556c81968a0e3c0d6/T-shape_mockup_back.png',
                val: 'T-Shape',
                description: 'Excellent shelf presence and easy handling, showcase your brand with a familiar pouch shape, perfect for snack food products.'
            },{
                image: 'https://images.ctfassets.net/tg5mrahr7vmv/7wKGH46nbSQENoF5aQ8dGF/bc9023bede540584dd2c267b6d0f2349/v-cut_quad_seal.png',
                image1: 'https://images.ctfassets.net/vhts96p7twn6/2KdE6GI9GJU3ScykTtlZ9O/200ef8e5ae8c6825bc7829f960c5fe4f/QSV_bottom.png',
                val: 'Quad Seal V-Cut',
                description: 'Featuring a unique V-shaped bottom, this bag maximizes shelf space and enhances product display, a great alternative to the box bottom coffee and food packaging.'
            },{
                image: 'https://images.ctfassets.net/tg5mrahr7vmv/r2v3upHoy1Ego6YZIUddh/46c0499cefbea8305bbde4303eba3116/QSBB_bag.png',
                image1: 'https://images.ctfassets.net/vhts96p7twn6/31LBjPu5EtrtdkLMQ7thlL/28575ac50d8d4eb854c039ffca9ab35f/QSBB_bottom.png',
                val: 'Quad Seal Box Bottom',
                description: 'Efficient, stable, and space-saving, this box bottom (flat bottom) pouch ensures your products stay upright and secure, perfect for that premium coffee and gourmet snack food appeal.'
            },{
                image: 'https://images.ctfassets.net/tg5mrahr7vmv/XmNg2Gr6kPeOnNZSgXTtL/5ec257ae697d127eeea14be8050f1a6e/squatty_box_bottom.png',
                image1: 'https://images.ctfassets.net/vhts96p7twn6/3UMRYp2ITnJVnbg7s2vlr1/0ed9f1e352ab2b105eed5c811b7f086d/SQUATTYBOXBOTTOM_BOTTOM.png',
                val: 'Squatty Box Bottom',
                description: 'Ultimate specialty coffee bag or gourmet snack vibes. Each panel, including the bottom gives you complete control over each facet of the bag; giving your customers the ultimate brand experience.'
            },{
                image: 'https://images.ctfassets.net/vhts96p7twn6/2INdOkV1RDLWbDjKgcPpaI/fd18ed441e654c2a1fcdcae01f58f576/tri-seal.png',
                image1: 'https://images.ctfassets.net/vhts96p7twn6/EyB1KJRa0NYm30KxUJwwv/55acb421cd5a91c27e363981b6b50631/tri-seal_v2.png',
                val: 'Tri-seal',
                description: 'Designed for ultimate protection and freshness, this pouch works perfectly on a small or large scale, perfect for tea, small samples of coffee, and more to ensure your products maintain quality and flavor.'
            },{
                image: 'https://images.ctfassets.net/tg5mrahr7vmv/6jafCguLYYqwiSrSCxuKdT/5d96b0b469cc6925d705b9ce01086808/sidegusset.png',
                image1: 'https://images.ctfassets.net/vhts96p7twn6/49NUer4nPGyyGs7zTAWTmD/a290a864cde4f80efef083cb9c6b7537/SIDEGUSSET_bottom.png',
                val: 'Side Gusset V-Cut',
                description: 'Your unique branding wraps around various coffee and food products in the perfect, affordable packaging option.'
            }
        ]
        return (
            <div className='packaging-print-house'>
                <CustomBuilder 
                    details={details}
                    formData={formData}
                    getInputProps={getInputProps}
                    getRootProps={getRootProps}
                    backdrop={backdrop}
                    setBackdrop={setBackdrop}
                    getDataShown={getDataShown}
                    setGetDataShown={setGetDataShown}
                    savedMessage={savedMessage}
                    loading={loading}
                    saveLoading={saveLoading}
                    handleGetData={handleGetData}
                    retrievedData={retrievedData}
                    handleChange={handleChange}
                    handlePackagingBuilder={handlePackagingBuilder}
                    handleSavePackagingBuilder={handleSavePackagingBuilder}
                />
                <ContentListing details={details} />
            </div>
        );
    } else return null
};